import React, { FC } from 'react';
import styles from './entity_breadcrumbs_container.module.scss';

export const EntityBreadcrumbsContainer: FC = ({ children }) => (
  <div className={styles.container}>
    <div className={styles.textContainer}>{children}</div>
  </div>
);
